import React from 'react';
import Navbar from '../components/Navbar';
import MyClaims from '../components/MyClaims';
import { Footer } from '../App'; // Import the Footer component from App.js

function MyClaimsPage() {
  return (
    <>
      <Navbar />
      <main className="app-main">
        <div className="container mx-auto px-4 py-8 mt-20">
          <MyClaims />
        </div>
      </main>
      <Footer />
    </>
  );
}

export default MyClaimsPage;